/*
 * Hairdealz (Claude, 28 Aug 2026) — back-in-stock e-mail capture.
 *
 * Posts to Klaviyo's public client endpoint. A 202 means the profile is now
 * waiting on that variant; Klaviyo releases the Back in Stock flow when
 * Shopify reports the variant back in stock.
 *
 * The block follows the variant picker: Minimog publishes every variant
 * change on MinimogTheme.pubSubEvents.variantChange with { data: { variant } },
 * and variant is null when the chosen option combination does not exist.
 */
(function () {
  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2024-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    if (root.dataset.hdBisReady) return;
    root.dataset.hdBisReady = '1';

    var form = root.querySelector('[data-hd-bis-form]');
    var input = form && form.querySelector('input[name="email"]');
    var button = form && form.querySelector('button');
    var message = root.querySelector('[data-hd-bis-msg]');
    if (!form || !input || !button || !message) return;

    function say(text, state) {
      message.textContent = text;
      message.hidden = false;
      message.className = 'hd-bis__msg hd-bis__msg--' + state;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = input.value.trim();
      if (!EMAIL_RE.test(email)) {
        say(root.dataset.msgInvalid, 'error');
        input.focus();
        return;
      }

      var variantId = root.dataset.variantId;
      if (!variantId) {
        say(root.dataset.msgError, 'error');
        return;
      }

      button.disabled = true;
      root.classList.add('hd-bis--busy');

      fetch(ENDPOINT + '?company_id=' + encodeURIComponent(root.dataset.companyId), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
              }
            }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo responded ' + response.status);
          say(root.dataset.msgSuccess, 'success');
          form.hidden = true;
        })
        .catch(function (error) {
          console.warn('[hd-bis]', error);
          say(root.dataset.msgError, 'error');
          button.disabled = false;
        })
        .then(function () {
          root.classList.remove('hd-bis--busy');
        });
    });

    // Follow the variant picker: show the block only while the chosen variant
    // cannot be bought, and always subscribe to the variant on screen.
    function watchVariants() {
      if (!window.MinimogEvents || !window.MinimogTheme) return false;
      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.available === false) {
          root.dataset.variantId = variant.id;
          form.hidden = false;
          message.hidden = true;
          button.disabled = false;
          root.hidden = false;
        } else {
          root.hidden = true;
        }
      });
      return true;
    }

    if (!watchVariants()) {
      var tries = 0;
      var timer = setInterval(function () {
        if (watchVariants() || ++tries > 20) clearInterval(timer);
      }, 250);
    }
  }

  function boot() {
    document.querySelectorAll('[data-hd-bis]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
